/**
 * Persists the last email/phone a customer used to log in, so returning users see it
 * pre-filled on the OTP request page.
 *
 * Uses localStorage rather than a cookie: the Customer Portal renders inside a cross-origin
 * iframe on the dealer's website, where third-party cookies are blocked (Safari/Firefox) or
 * partitioned (Chrome). localStorage is partitioned per top-level site too, but it is not
 * blocked outright, so it persists reliably per dealer site. All access is guarded so a
 * blocked/unavailable store (private mode, disabled storage) degrades to no prefill.
 */
const STORAGE_KEY = "cp_last_identifier";

/**
 * Stores the identifier (email or phone) the customer just used.
 */
export const saveCustomerPortalIdentifier = (identifier: string): void => {
  if (!identifier) return;

  try {
    window.localStorage.setItem(STORAGE_KEY, identifier);
  } catch {
    // Storage can throw in sandboxed/blocked iframe contexts — ignore, prefill is optional.
  }
};

/**
 * Reads the previously stored identifier, or an empty string when none is available.
 */
export const getCustomerPortalIdentifier = (): string => {
  try {
    return window.localStorage.getItem(STORAGE_KEY) ?? "";
  } catch {
    return "";
  }
};
